import { useNavigate, useParams } from "react-router-dom";
import MainLayout from "../../../layouts/MainLayout";
import "../../../assets/styles/custom-styles.css";
import Form from "../../../components/forms/Form";
import { locationFields } from "../../../constants/forms/locationFields";
import useBaseService from "../../../hooks/services/useBaseService";
import useForm from "../../../hooks/useForm";
import {
  cleanPayload,
  normalizeFormErrors,
  setDefaultFieldValues,
} from "../../../utils/objectUtils";
import { entities } from "../../../constants/entities";
import PageHeader from "../../../components/PageHeader";
import SimpleBody from "../../../components/forms/SimpleBody";
import SectionHeader from "../../../components/forms/SectionHeader";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useLoader from "../../../hooks/useLoader";
import useNotification from "../../../hooks/useNotification";

const CreateOrganizationLocationPage = () => {
  const navigate = useNavigate();
  const { organizationId, addressId } = useParams();
  const { post: baseServicePost, formErrors } = useBaseService(navigate);
  const { formData, handleChange } = useForm(
    setDefaultFieldValues(locationFields)
  );
  const { showLoader, hideLoader } = useLoader();
  const { showNotification } = useNotification();
  const queryClient = useQueryClient();

  const createLocationMutation = useMutation({
    mutationFn: async (data) => {
      showLoader();
      const response = await baseServicePost(
        entities.organizations.organizationAddressLocationCreate(
          organizationId,
          addressId
        ),
        data
      );
      return response;
    },
    onSuccess: (response) => {
      if (response?.status === 201) {
        hideLoader();
        queryClient.invalidateQueries({
          queryKey: ["locationsOrganization", organizationId, addressId],
        });
        navigate(
          `/aluguel/organizacoes/detalhes/${organizationId}/enderecos/${addressId}/localizacoes`,
          {
            replace: true,
          }
        );
      }
      hideLoader();
    },
    onError: (error) => {
      console.error("onError ", error);
      hideLoader();
    },
  });

  const handleSubmit = async () => {
    try {
      const cleanedData = cleanPayload(formData);
      await createLocationMutation.mutateAsync(cleanedData);
    } catch (error) {
      console.error("Erro ao enviar localização:", {
        status: error.status,
        message: error.message,
      });
    }
  };

  const handleBack = () => {
    navigate(
      `/aluguel/organizacoes/detalhes/${organizationId}/enderecos/${addressId}/localizacoes`
    );
  };

  return (
    <MainLayout selectedCompany="ALUCOM">
      <PageHeader
        title="Cadastro de Localização"
        showBackButton={true}
        backUrl={`/aluguel/organizacoes/detalhes/${organizationId}/enderecos/${addressId}/localizacoes`}
      />
      <div className="container-fluid p-1">
        <Form
          onSubmit={handleSubmit}
          initialFormData={formData}
          textSubmit="Cadastrar"
          textLoadingSubmit="Cadastrando..."
          handleBack={handleBack}
        >
          {() => {
            const renderedSections = new Set();

            return locationFields.map((section, index) => {
              const sectionType = section.section.split(" - ")[0];
              const showHeader = !renderedSections.has(sectionType);

              if (showHeader) {
                renderedSections.add(sectionType);
              }

              return (
                <div key={section.section + " " + index}>
                  {showHeader && (
                    <SectionHeader
                      section={section.section}
                      viewTable={false}
                      setViewTable={() => {}}
                      addFieldsInData={() => {}}
                    />
                  )}

                  <SimpleBody
                    fields={section.fields}
                    formErrors={normalizeFormErrors(formErrors)}
                    formData={formData}
                    handleFieldChange={handleChange}
                    getOptions={() => {}}
                    getSelectedValue={() => {}}
                  />
                </div>
              );
            });
          }}
        </Form>
      </div>
    </MainLayout>
  );
};

export default CreateOrganizationLocationPage;
